import {PROPERTIES_WITH_SINGLE_UNIT} from '../UnitConversion/Properties';

import type {CSSProperty} from '../types';

export const validateForUnits = (cssKey: string, value: string | number, unit: string): string => {
    let result = value;

    if (PROPERTIES_WITH_SINGLE_UNIT.includes(cssKey as CSSProperty)) {
        if (typeof value === 'number') {
            result = `${value}${unit}`;
        } else if (value === parseFloat(value).toString()) {
            result = parseFloat(value) + unit;
        } else if (unit === 'auto' || value.toLowerCase?.().includes('auto')) {
            result = 'auto';
        } else if (value.length > 1 && value[0] === '0') {
            result = parseFloat(value) + unit;
        } else if (parseFloat(value).toString() === 'NaN') {
            result = '0' + unit;
        }
    }

    result = `${result}`.trim();

    return result;
};
